import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PromoLink = styled(Link)`
    cursor: pointer;
    color: #006AFF;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 21px;
`;

export const TooltipLink = styled(Link)`
    cursor: pointer;
    color: #ffffff;
    text-decoration: underline;
`;

export default {
    PromoLink,
    TooltipLink,
};
